import { Color } from '@tiptap/extension-color';
import FontFamily from '@tiptap/extension-font-family';
import Highlight from '@tiptap/extension-highlight';
import ListItem from '@tiptap/extension-list-item';
import TextAlign from '@tiptap/extension-text-align';
import { TextStyle } from '@tiptap/extension-text-style';
import StarterKit from '@tiptap/starter-kit';
import ActivityBlock from './ActivityBlockExtension';
import ColumnDropPlugin from './ColumnDropPlugin';
import Column from './ColumnExtension';
import ColumnLayout from './ColumnLayoutExtension';
import ContentItem from './ContentItemExtension';
import CustomBulletList from './CustomBulletListExtension';
import CustomHeading from './CustomHeadingExtension';
import CustomOrderedList from './CustomOrderedListExtension';
import CustomParagraph from './CustomParagraphExtension';
import { FontSize } from './FontSizeExtension';
import WordMatrixContent from './WordMatrixContentExtension';
import WritingLine from './WritingLinesExtension';

/**
 * Shared TipTap extensions used by both the lesson planner and learner worksheet.
 * View-specific extensions (e.g. LessonGuidanceBlock, Placeholder) should be
 * added in the consuming component.
 */
export const sharedEditorExtensions = [
  StarterKit.configure({
    heading: false,
    paragraph: false,
    bulletList: false,
    orderedList: false,
    listItem: false,
  }),
  TextStyle,
  Color,
  Highlight.configure({ multicolor: true }),
  WritingLine,
  FontSize,
  FontFamily.configure({
    types: ['textStyle'],
  }),
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
  ActivityBlock,
  ColumnLayout,
  Column,
  ColumnDropPlugin,
  CustomParagraph,
  CustomHeading,
  ContentItem,
  CustomBulletList,
  CustomOrderedList,
  ListItem,
  WordMatrixContent,
];
